import Vue from 'vue';
import {
  LIST,
  EXCEL_FILE_LIST,
} from './mutation-types';

export default {

  [LIST](state, response) {
    state.mediaInfos = response.mediaInfos;
  },

  [EXCEL_FILE_LIST](state, response) {
    state.excelFiles = response.excelFiles;
    state.excelFileTotal = response.totalCnt;
  },

};
